export default {
  filters: {
    cutHash(v) {
      let valStart = v.substring(0, 6);
      let valEnd = v.substring(v.length - 5, v.length);
      return `${valStart}...${valEnd}`;
    },
  },
};
